import React from "react";
import { ResetEmailContainer } from "modules";

type Props = {};

const ResetEmail = (props: Props) => {
    return <ResetEmailContainer />;
};

export default ResetEmail;
